import {equityAccountView, EquityAccountView} from "./view/EquityAccountViewComponent";
import {equityAccountViewStoreFactory} from "./store/EquityAccountViewStoreFactory";

import Components from "./components";
import Services from "./services";
import { react2angular } from "react2angular";
import {BankDetails} from "../../components/react/component/BankDetails";

export default function() {
    const ModuleName = "tfApp.account.equity";
    return angular.module(ModuleName, [Components(ModuleName), Services(ModuleName)])
                  .component(EquityAccountView, equityAccountView())
                  .component("reactBankDetails", react2angular(BankDetails, ["summary"], ["$translate", "languageService", "currentUserService"]))
                  .service("equityAccountViewStoreFactory", equityAccountViewStoreFactory)
                  .name;
}
